var _process$env$OV_ID_CO = process.env.OV_ID_COOKIE_PREFIX,
    OV_ID_COOKIE_PREFIX = _process$env$OV_ID_CO === void 0 ? 'ovid-dev' : _process$env$OV_ID_CO;
var _process$env$OV_ID_CO2 = process.env.OV_ID_COOKIE_DOMAIN,
    COOKIE_DOMAIN = _process$env$OV_ID_CO2 === void 0 ? '.ov.com' : _process$env$OV_ID_CO2;
export { COOKIE_DOMAIN };
export var JWT_COOKIE_NAME = "".concat(OV_ID_COOKIE_PREFIX, "-jwt");
export var REFRESH_COOKIE_NAME = "".concat(OV_ID_COOKIE_PREFIX, "-refresh");